import Vue from 'vue'
import App from './App.vue'
import router from './router'
//设置网页title的组件
import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)
import global_ from './components/Global' //引用文件
Vue.prototype.GLOBAL = global_ //挂载到Vue实例上面
import FastClick from 'fastclick' 
import getAppid from './utils/getAppid.js'
Vue.prototype.getAppid = getAppid;
// import F2 from '@antv/f2'
import F2 from '@antv/f2/lib/index-all'
Vue.prototype.$F2= F2;
Vue.config.productionTip = false
FastClick.prototype.focus = function (targetElement) {
  let length;
  if (targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month') {
    length = targetElement.value.length;
    targetElement.focus();
    targetElement.setSelectionRange(length, length);
  } else {
    targetElement.focus();
  }
};
FastClick.attach(document.body)
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
